import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { GridOptions } from 'ag-grid-community';
import { SettingsService } from '../../../../core/settings/settings.service';
import { CeqTableComponent } from '../../../common/ceq-table/ceq-table.component';
import { DeleteChildRendered } from '../../../common/renders/delete-child-rendered';
import { EditChildRendered } from '../../../common/renders/edit-child-rendered';
import { CurrencyService } from '../currency.service';
import * as moment from 'moment';
import { GlobalFunctionsService } from 'src/app/ceq/common/functions/global-functions.service';

@Component({
  selector: 'app-currency-list',
  templateUrl: './currency-list.component.html',
  styleUrls: ['./currency-list.component.scss']
})
export class CurrencyListComponent implements OnInit {
  @ViewChild('CeqGrid', { static: false }) ceqGrid: CeqTableComponent;

  options: GridOptions;
  PageSizes = [10, 25, 50, 100, 1000];
  org: number;

  gridOptions = {
    context: this,
    frameworkComponents: {
      childEditRenderer: EditChildRendered,
      childDeleteMessageRenderer: DeleteChildRendered
    },
    suppressHorizontalScroll: true,
    onRowDoubleClicked: (params: any) => this.edit(params),
    icons: {
      sortAscending: '<i class="fa fa-sort-up" style="margin-left:10px"></i>',
      sortDescending: '<i class="fa fa-sort-down" style="margin-left:10px"></i>',
      sortUnSort: '<i class="fa fa-sort" style="margin-left:10px"></i>'
    }
  };

  columnDefs = [
    {
      headerName: 'Código',
      field: 'currencyCode',
      flex: 1,
      minWidth: 100,
      sortable: true,
      resizable: true,
    },
    {
      headerName: 'Nombre',
      field: 'currencyName',
      flex: 3,
      sortable: true,
      resizable: true,
    },
    {
      headerName: 'Última modificación',
      field: 'ModifiedAt',
      flex: 2,
      sortable: true,
      cellRenderer: (params: any) => params.value ? moment(params.value).format('YYYY-MM-DD HH:mm:ss') : '-'
    },
    {
      headerName: 'Modificado por',
      field: 'ModifiedBy',
      flex: 2,
    },
    {
      headerName: 'Editar',
      width: 80,
      cellRenderer: 'childEditRenderer',
      cellClass: 'text-center',
      resizable: false,
    },
    {
      headerName: 'Eliminar',
      width: 80,
      cellRenderer: 'childDeleteMessageRenderer',
      cellClass: 'text-center',
      resizable: false,
    }
  ];

  constructor(
    private currencyService: CurrencyService, 
    private globalFunctionService: GlobalFunctionsService, 
    private settings: SettingsService, 
    private router: Router
  ) { }

  ngOnInit(): void {
    this.org = this.settings.getUser().Org;
  }

  gridEmiter(GridOptions: GridOptions) {
    this.options = GridOptions;
    this.getCurrency();
  }

   async refresh(){
    this.getCurrency();
  }

  onPageSizeChange(value: any) {
    // Aquí podrías implementar la lógica de cambio de tamaño si tu ceq-table lo soporta
    console.log("Nuevo tamaño de página:", value);
  }

  getCurrency() {
    this.ceqGrid.showLoading();
    this.currencyService.getCurencyList().subscribe({
      next: (data) => {
        this.ceqGrid.data = data;
        this.ceqGrid.hidenloading();
      },
      error: () => this.globalFunctionService.messageBimbo("Error al cargar las monedas", 'error', 'Error')
    });
  }

  btnAddClick() {
    this.router.navigate(['/tax/currency/create']);
  }

  edit(row: any) {
    this.router.navigate([`/tax/currency/${row.data.currencyId}`]);
  }

  async delete(row: any) {
    const confirm = await this.globalFunctionService.messageBimbo(
      `¿Desea eliminar la moneda ${row.data.currencyCode}?`, 
      'question1', 
      'Confirmación'
    );

    if (confirm) {
      this.currencyService.deleteCurrency(row.data.currencyId).subscribe({
        next: async () => {
          await this.globalFunctionService.messageBimbo('Moneda eliminada correctamente.', 'success', '¡Éxito!');
          this.getCurrency();
        },
        error: async (err) => {
          const errorMsg = err.error || 'No se pudo eliminar el registro';
          await this.globalFunctionService.messageBimbo(errorMsg, 'error', '¡Error!');
        }
      });
    }
  }
}